"use client";

import React from "react";
import MCMComboboxExample from "@/examples/MCMComboboxExample";

export default function MCMComboboxExamplePage() {
  return (
    <div className="container mx-auto p-6">
      <MCMComboboxExample />
    </div>
  );
}
